@if (embedded()) {
  <ng-container *ngTemplateOutlet="pathwayContent" />
} @else {
  <cfp-report-page
    [portfolioTitle]="customerName()"
    [translationKeyPrefix]="translationKeyPrefix"
    [headerLogo]="headerLogo()"
    [chromeFooter]="chromeFooter()"
    [lastPage]="lastPage()"
    data-test="reportRoadmapBuildingPathwayPage"
  >
    @if (building().building) {
      <cfp-building-details-header
        [building]="buildingDetails()"
        [hideSelect]="true"
        [hideGoToAllBuildings]="true"
        [hideDeleteBuilding]="true"
        [canDownloadReport]="false"
        [buildingHeaderClass]="'col-auto'"
        [energyLabelRequirement]="energyLabelRequirement()"
        [onlyAllowNgContent]="true"
      >
        <cfp-report-building-energy-label-alert
          [energyLabels]="building().energyLabels"
          [objectType]="building().building.objectType"
        />
      </cfp-building-details-header>
    }

    <ng-container *ngTemplateOutlet="pathwayContent" />
  </cfp-report-page>
}

<ng-template #pathwayContent>
  <h2>{{ 'lbgPortfolioRoadmapReport.decarbonisationPathway.building.title' | translate }}</h2>
  <p>{{ 'lbgPortfolioRoadmapReport.decarbonisationPathway.building.description' | translate }}</p>

  <div class="decarbonisation-pathway-total mb-4">
    <cfp-icon [icon]="'check-circle'" [iconType]="'solid'" [iconStyle]="'success'" [classes]="'me-3'" />
    <div>
      <div class="decarbonisation-pathway-total-label">
        {{ 'lbgPortfolioRoadmapReport.decarbonisationPathway.totalReduction' | translate }}
      </div>
      <div class="decarbonisation-pathway-total-value">
        {{ pathway().totalCo2IntensityReductionPercentage | number: '1.0-0' }}%
      </div>
    </div>
  </div>

  <cfp-lbg-decarbonisation-pathway-chart
    [pathway]="pathway()"
    [yAxisTitleKey]="'lbgPortfolioRoadmapReport.decarbonisationPathway.yAxis.building'"
  />
</ng-template>
